(function () {
  'use strict';

  var root = document.querySelector('[data-maintenance-countdown]');
  if (!root) return;

  var endRaw = root.getAttribute('data-end');
  if (!endRaw) return;

  var endMs = Date.parse(endRaw);
  if (isNaN(endMs)) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var units = ['days', 'hours', 'minutes', 'seconds'];
  var els = {};
  var progressBar = root.querySelector('[data-countdown-progress]');
  var doneEl = root.querySelector('[data-countdown-done]');
  var gridEl = root.querySelector('.maintenance-countdown__grid');

  units.forEach(function (unit) {
    var node = root.querySelector('[data-unit="' + unit + '"]');
    if (node) els[unit] = node;
  });

  var startMs = Date.now();
  var totalMs = Math.max(endMs - startMs, 1);
  var lastSeconds = -1;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function setUnit(unit, value, animate) {
    var el = els[unit];
    if (!el) return;
    var next = unit === 'days' ? String(value) : pad(value);
    if (el.textContent === next) return;
    if (animate && !reducedMotion && unit === 'seconds') {
      el.classList.remove('maintenance-countdown__value--tick');
      void el.offsetWidth;
      el.classList.add('maintenance-countdown__value--tick');
    }
    el.textContent = next;
  }

  function tick() {
    var now = Date.now();
    var diff = Math.max(0, endMs - now);

    var days = Math.floor(diff / 86400000);
    var hours = Math.floor((diff % 86400000) / 3600000);
    var minutes = Math.floor((diff % 3600000) / 60000);
    var seconds = Math.floor((diff % 60000) / 1000);

    setUnit('days', days, false);
    setUnit('hours', hours, false);
    setUnit('minutes', minutes, false);
    setUnit('seconds', seconds, seconds !== lastSeconds);
    lastSeconds = seconds;

    if (progressBar) {
      var elapsed = Math.min(1, (now - startMs) / totalMs);
      progressBar.style.width = (elapsed * 100).toFixed(2) + '%';
    }

    if (diff <= 0) {
      if (gridEl) gridEl.hidden = true;
      if (doneEl) doneEl.hidden = false;
      root.setAttribute('data-complete', 'true');
      return false;
    }
    return true;
  }

  if (!tick()) return;

  var interval = setInterval(function () {
    if (!tick()) clearInterval(interval);
  }, 1000);
})();
